import { message } from 'antd'
import { CargoApi } from '../../../../api/Purchase/Cargo'
import DeliveryRoute from '../../../../components/Purchasing/Cargo/Routes/DeliveryRoute'
import { pick, get, isEmpty } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function DeliveryRouteCont(props) {
  const { cargo, isUpdatable } = props
  const { list, fetching, fetch } = useFetchList(
    () => CargoApi.getRoutesByCargo(cargo._key),
    [cargo._key],
    isEmpty(cargo._key),
  )

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, CargoApi.route.update, CargoApi.route.remove, undefined)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await CargoApi.route.create({
        ...newObject,
        cargo: pick(cargo, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const isConfirmed = cargo.status === 'Confirmed'

  return (
    <DeliveryRoute
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        cargo,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        isConfirmed,
        remove,
        update,
        modalType,
        isUpdatable,
        formRef,
      }}
    />
  )
}

DeliveryRouteCont.propTypes = {}
DeliveryRouteCont.defaultProps = {}

export default (DeliveryRouteCont)
